import Api from 'src/api/Base'

class GetFeatureToggles extends Api {
  requestUrl = `/api/FeatureToggle`

  method = 'GET'
}

export default GetFeatureToggles
